import { onSignal } from 'listeners/lib/signalTrackerListener';

const calendarDataTimings = {};

export default function getCalendarDataTimings() {
    return calendarDataTimings;
}

export function trackSignalsForLog(
    signalLogPairs: {
        signalName: string;
        logName: string;
    }[]
) {
    signalLogPairs?.forEach((item: { signalName: string; logName: string }) => {
        setupSignalForLogging(item.signalName, item.logName);
    });
}

export function trackCalendarDataTimings() {
    const signalLogPairs = [
        {
            signalName: 'GET_CALENDAR_VIEW_CACHE_HIT',
            logName: 'ecech',
        },
        {
            signalName: 'NetworkCalendarEventsReceived',
            logName: 'evadd',
        },
        {
            signalName: 'GetCalendarEventRequestsMade',
            logName: 'gcerm',
        },
        {
            signalName: 'InitializeCalEventStore',
            logName: 'ices',
        },
    ];
    trackSignalsForLog(signalLogPairs);
}

async function setupSignalForLogging(signalName: string, logName: string) {
    const data = await onSignal(signalName);

    if (data?.customData) {
        const { time } = data.customData;
        calendarDataTimings[logName] = time ? Math.floor(+time) : null;
    }
}
